import { Box, Button, Icon, Typography } from '@mui/material';
import {
  greatPlaceStyle,
  infoWindowStyle,
  taxiPlaceStyle,
} from './MarketStyles';
import { useState } from 'react';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { InfoWindow, Marker } from '@vis.gl/react-google-maps';

const MarketExtraInfo = data => {
  return (
    <div style={infoWindowStyle}>
      <div style={{ fontSize: 16 }}>{data.title}</div>
      <div style={{ fontSize: 14 }}>
        <span style={{ color: 'grey' }}>{data.rating} </span>
        <span style={{ color: 'orange' }}>
          {String.fromCharCode(9733).repeat(Math.floor(data.rating))}
        </span>
        <span style={{ color: 'lightgrey' }}>
          {String.fromCharCode(9733).repeat(5 - Math.floor(data.rating))}
        </span>
      </div>
      <div style={{ fontSize: 14, color: 'grey' }}>{data.types[0]}</div>
      <div style={{ fontSize: 14, color: 'grey' }}>
        {'$'.repeat(data.price_level)}
      </div>
      <div style={{ fontSize: 14, color: 'green' }}>
        {data.opening_hours.open_now ? 'Open' : 'Closed'}
      </div>
    </div>
  );
};

const LocationMarker = ({ title, lat, lng, placeAddressName }) => {
  return <div style={greatPlaceStyle}>{title}</div>;
};

const TaxiMarker = ({ title, lat, lng, driverData, taxiStatus = 'free' }) => {
  const [showExtraInfo, setShowExtraInfo] = useState(false);

  const onMarkerClick = () => {
    setShowExtraInfo(!showExtraInfo);
  };

  return (
    <Button style={{}} onClick={onMarkerClick}>
      {taxiStatus === 'bussy' ? (
        <img
          src="https://img.recraft.ai/0E88jcPt-6RaDfkM18Cu7BYMGyiBP0da1J9C4L0TJuI/rs:fit:1024:1024:0/q:80/g:no/plain/abs://prod/images/b443fc34-2dc5-453d-9d8b-cee158e91fb6@avif"
          alt="taxi"
          srcSet=""
          style={{ ...taxiPlaceStyle }}
        />
      ) : (
        <img
          src="https://th.bing.com/th/id/R.edeba5e177ef2b03a7cbf1990018fb12?rik=PallBDqlfvBAxQ&pid=ImgRaw&r=0"
          alt="taxi"
          srcSet=""
          style={{ ...taxiPlaceStyle }}
        />
      )}

      {showExtraInfo && (
        <div style={infoWindowStyle}>
          <div style={{ fontSize: 14 }}> Taxista </div>
          <div
            style={{ fontSize: 12, color: '#000', textTransform: 'capitalize' }}
          >
            {`${driverData.firstName} ${driverData.lastName}`}
          </div>
          <div style={{ fontSize: 12, color: '#000' }}>
            {driverData.mobile.replace('+57', '')}
          </div>

          <div style={{ fontSize: 10, color: 'grey' }}>
            {driverData.arriveTime.timein_text} | {'\t'}
            {Number(driverData.distance).toFixed(2)} km
          </div>
        </div>
      )}
    </Button>
  );
};

const SelectPlaceMarker = ({
  title,
  lat,
  lng,
  setOrigin,
  setDestination,
  coords,
  setNewCoords,
}) => {
  const [showOptions, setShowOptions] = useState(true);

  const fetchAddressData = async () => {
    const urlRequest = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords.lat},${coords.lng}`;
    const additionalOptions = `&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCWTd8Bk9enX-j4lzSPWBDRQGim3XLGF2s'}`;
    
    try {
      const response = await fetch(urlRequest + additionalOptions);
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        return {
          addressName: data.results[0].formatted_address,
          add: data.results[0].formatted_address,
          description: data.results[0].formatted_address,
        };
      }
      
      // Fallback si no hay resultados
      return {
        addressName: `Ubicación ${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`,
        add: `Ubicación ${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`,
        description: `Ubicación ${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`,
      };
    } catch (error) {
      console.error('Error fetching address:', error);
      // Fallback en caso de error
      return {
        addressName: `Ubicación ${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`,
        add: `Ubicación ${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`,
        description: `Ubicación ${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`,
      };
    }
  };

  const onOriginClick = async () => {
    try {
      const data = await fetchAddressData();
      setOrigin({
        coords,
        addressName: data.addressName,
        description: data.description,
        add: data.add,
      });
      setShowOptions(false);
    } catch (error) {
      console.error('Error setting origin:', error);
    }
  };

  const onDestinationClick = async () => {
    try {
      const data = await fetchAddressData();
      setDestination({
        coords,
        addressName: data.addressName,
        description: data.description,
        add: data.add,
      });
      setShowOptions(false);
    } catch (error) {
      console.error('Error setting destination:', error);
    }
  };

  const onCancelClick = () => {
    setNewCoords(null);
    setShowOptions(false);
  };

  return (
    <>
      <Marker
        position={{ lat: coords.lat, lng: coords.lng }}
        icon={{
          url: "https://maps.google.com/mapfiles/ms/icons/purple-dot.png",
          scaledSize: { width: 32, height: 32 }
        }}
        onClick={() => setShowOptions(!showOptions)}
      />
      
      {showOptions && (
        <InfoWindow
          position={{ lat: coords.lat, lng: coords.lng }}
          onCloseClick={onCancelClick}
        >
          <Box sx={{ 
            p: 2, 
            minWidth: 200,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}>
            <Typography variant="body2" sx={{ 
              fontWeight: 600, 
              mb: 1, 
              textAlign: 'center',
              color: 'primary.main'
            }}>
              Seleccionar como:
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Button
                variant="contained"
                size="small"
                fullWidth
                onClick={onOriginClick}
                sx={{
                  backgroundColor: '#4CAF50',
                  '&:hover': { backgroundColor: '#45a049' },
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                🟢 Punto de Recogida
              </Button>
              
              <Button
                variant="contained"
                size="small"
                fullWidth
                onClick={onDestinationClick}
                sx={{
                  backgroundColor: '#f44336',
                  '&:hover': { backgroundColor: '#d32f2f' },
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                🔴 Punto de Destino
              </Button>
              
              <Button
                variant="outlined"
                size="small"
                fullWidth
                onClick={onCancelClick}
                sx={{
                  color: 'text.secondary',
                  borderColor: 'divider',
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                ✖️ Cancelar
              </Button>
            </Box>
          </Box>
        </InfoWindow>
      )}
    </>
  );
};

class CustomMapMark {
  static createTaxiMarket(params) {
    return <TaxiMarker {...params} />;
  }

  static createLocationMarket(params) {
    return <LocationMarker {...params} />;
  }

  static createSelectPlaceMarket(params) {
    return <SelectPlaceMarker {...params} />;
  }
}

export default CustomMapMark;
